export type FieldKind = 'text' | 'select' | 'checkbox' | 'datetime' | 'updated_at' | 'number';

export interface FieldDefinition {
  name: string;
  id: string;
  type: FieldKind;
  multiple?: boolean;
  options?: readonly string[];
}

export const STANDARD_CATEGORIES = [
  '分类-01_项目计划',
  '分类-02_项目运营',
  '分类-03_技术方案',
  '分类-04_认证法规准入',
  '分类-05_发运测试上牌',
  '分类-06_成本预算资源',
  '分类-07_投产交付',
  '分类-08_量产运营',
  '分类-09_市场信息',
  '分类-10_产品配置',
] as const;

export const AGENT_FIELDS = [
  { name: '负责范围', id: 'fldTyTFZj7', type: 'select', multiple: true, options: ['F平台','G平台','D平台','平台化专项','流程规范','跨平台','其他'] },
  { name: '阶段', id: 'fldr5MzOJq', type: 'text' },
  { name: '类型', id: 'fldw3t2y1l', type: 'select', options: ['原文资料','知识点'] },
  { name: '系统更新时间', id: 'fldLSaOlGC', type: 'updated_at' },
  { name: '一级目录', id: 'fldzk6vF0O', type: 'select', options: ['00_总览与入口','01_平台项目','02_项目过程','03_问题风险','04_技术产品','05_法规认证','06_测试验证','07_发运上牌','08_成本资源','09_流程模板','10_经验复盘','99_待处理', ...STANDARD_CATEGORIES] },
  { name: '归并到', id: 'fldcmgkjlh', type: 'text' },
  { name: '人工确认', id: 'fld8cQhEFc', type: 'select', options: ['纳入','不纳入'] },
  { name: '关键词', id: 'fldcITX10l', type: 'text' },
  { name: '召回状态', id: 'fldAXu8MCc', type: 'select', options: ['可召回','仅存档','不召回-已合并','不召回-重复/无效','待人工判断'] },
  { name: '知识集合', id: 'fld7Npszac', type: 'text' },
  { name: '原文链接', id: 'fldSIpvUMJ', type: 'text' },
  { name: '最近校验时间', id: 'fldJ0QjhAO', type: 'datetime' },
  { name: '证据位置', id: 'fld5OmFJeQ', type: 'text' },
  { name: '整理状态', id: 'fldZekPxVF', type: 'select', options: ['待扫描','已入库','待整理','已生成知识点','需人工确认','已合并/不再召回'] },
  { name: '适用国家/地区', id: 'fldHgqB8OZ', type: 'text' },
  { name: '业务域', id: 'fldcyQ5vvv', type: 'select', multiple: true, options: ['需求管理','项目管理','上会材料','流程规范','发运物流','法规认证','质量问题','风险决策','会议纪要','市场分析','其他','整车','适应验证','项目计划','项目阀门','认证法规准入','技术方案','试验验证','零部件管理'] },
  { name: '目录路径', id: 'fld69XmbLS', type: 'text' },
  { name: '标题/问题', id: 'fldarQz3Hd', type: 'text' },
  { name: '摘要/结论', id: 'fldFDJxOyD', type: 'text' },
  { name: '责任人/录入人', id: 'fldvFZOFFB', type: 'text' },
  { name: '知识粒度', id: 'fldXDG7Da8', type: 'select', options: ['目录入口','项目总览','专题闭环','问题闭环','会议闭环','单一决策','原文存档','碎片/不召回'] },
  { name: '平台/项目', id: 'fld1GLSZoN', type: 'text' },
  { name: '人类主题', id: 'fldvzm7zqR', type: 'select', multiple: true, options: ['项目计划/节点','会议纪要/同步','风险/问题闭环','法规/认证','发运/清关/上牌','产品/市场/配置','技术/系统方案','测试/DVP/验证','成本/预算/资源','流程/模板/规范','经验案例/复盘','待开权/待确认'] },
  { name: '目录可见', id: 'fldZvpkQX6', type: 'checkbox' },
  { name: '所属目录', id: 'fldAUUlgao', type: 'select', options: ['流程规范','F平台','G平台','D平台','平台化专项','其他'] },
  { name: '备注/待补充', id: 'flde8ldrxr', type: 'text' },
  { name: '可信等级', id: 'fldHdyfEIm', type: 'select', options: ['高：有原文明确证据','中：原文可支撑但需结合判断','低：信息不完整','需验证','高'] },
  { name: '合并主键', id: 'fldoB5p3Xv', type: 'text' },
  { name: '三级目录/专题', id: 'fld2IZDy1A', type: 'text' },
  { name: '录入批次', id: 'fldllsADKK', type: 'text' },
  { name: '条目角色', id: 'fldJXbiUAz', type: 'select', options: ['主知识点','支撑原文','集合入口','被合并子项','重复/无效','待判断'] },
  { name: '二级目录', id: 'fldmjNL6Ho', type: 'select', options: ['项目总览','项目计划/节点','会议纪要/同步','决策/上会','风险清单','问题闭环/日清','技术方案/系统方案','产品配置/市场需求','法规校核/准入认证','保险/防盗/NCAP','测试计划/DVP','试验车/联调','发运/清关','上路/上牌/临牌','预算/成本/资源','流程规范/操作手册','模板/表单','复盘/参考案例','待开权/需确认','其他'] },
] as const satisfies readonly FieldDefinition[];

export const OPERATIONS_FIELDS = [
  { name: '长期待开权数', id: 'fldhUXLZMY', type: 'number' },
  { name: '生成时间', id: 'fldnYjYbBV', type: 'datetime' },
  { name: '本周新增知识点数', id: 'fldGkY9uf0', type: 'number' },
  { name: '结论/动作', id: 'fldu6bp6gX', type: 'text' },
  { name: '运营状态', id: 'fld2YduL48', type: 'select', options: ['正常','关注','阻塞'] },
  { name: '本周新增原文数', id: 'fldXl0xNSs', type: 'number' },
  { name: '待人工确认数', id: 'fldQWahIP7', type: 'number' },
  { name: '无权限待开权数', id: 'fld7bo79or', type: 'number' },
  { name: '周期', id: 'fldr00Pteo', type: 'text' },
  { name: '录入范围', id: 'fldgcVbUmG', type: 'select', multiple: true, options: ['F平台','G平台','D平台','平台化专项','跨平台','流程规范','其他','全录入'] },
] as const satisfies readonly FieldDefinition[];

export const FIELD = Object.fromEntries(AGENT_FIELDS.map((field) => [field.name, field.id])) as Record<(typeof AGENT_FIELDS)[number]['name'], string>;

export const REQUIRED_AGENT_FIELD_NAMES = [
  '标题/问题','类型','系统更新时间','一级目录','人工确认','原文链接','整理状态','目录路径','摘要/结论','平台/项目','目录可见','所属目录','录入批次','二级目录','三级目录/专题'
] as const;
